<template>
    <div>
        <div class="content-caption dashed bg-white">
            <span>基本信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{orderGoodsAllocForm.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>要求到货日期</label>
                </div>
                <div class="form-value">
                    <span>{{orderGoodsAllocForm.desireArriveDate}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="orderGoodsAllocForm.orderNo != null">
                <div class="form-label">
                    <label>订单编号</label>
                </div>
                <div class="form-value">
                    <span>{{orderGoodsAllocForm.orderNo}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed bg-white">
            <span>配货机构</span>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">业务单元</th>
                <th style="text-align: left">所属部门</th>
                <th style="text-align: left">地址</th>
                <th style="text-align: left">邮箱</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="retailerCom != null" class="row">
                <td style="text-align: left">{{retailerCom.bizUnitName}}</td>
                <td style="text-align: left">{{retailerCom.name}}</td>
                <td style="text-align: left">{{retailerCom.regionName + retailerCom.street}}</td>
                <td style="text-align: left">{{retailerCom.contactEmail}}</td>
            </tr>
            <tr class="row" v-else>
                <td colspan="3">暂无机构信息</td>
            </tr>
            </tbody>
        </table>
        <div class="content-caption dashed bg-white">
            <span>地址信息</span>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">地址信息</th>
                <th style="text-align: left">详细地址</th>
                <th style="text-align: left">联系人</th>
                <th style="text-align: left">联系电话</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="retailerCom != null" class="row">
                <td style="text-align: left">
                    <div>{{orderGoodsAllocForm.buyerRecvRegionName}}</div>
                </td>
                <td style="text-align: left">
                    <div>{{orderGoodsAllocForm.buyerRecvStreet}}</div>
                </td>
                <td style="text-align: left">
                    <div>{{orderGoodsAllocForm.buyerRecvContractName}}</div>
                </td>
                <td style="text-align: left">
                    <div>{{orderGoodsAllocForm.buyerRecvContactTel}}</div>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="content-caption dashed bg-white">
            <span>商品信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>供应商：</label>
                </div>
                <div class="form-value">
                    <span>{{orderGoodsAllocForm.sellerName}}</span>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-form :model="orderGoodsAllocForm">
                <el-table ref="multipleTable" :data="orderGoodsAllocForm.itemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                        <el-table-column align="left" prop="devcName" label="名称"></el-table-column>
                        <el-table-column align="left" prop="devcCatName" label="分类"></el-table-column>
                        <el-table-column align="left" prop="devcBrandName" label="品牌"></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息">
                        <el-table-column align="left" prop="title" label="名称"></el-table-column>
                        <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                        <el-table-column align="left" prop="brandName" label="品牌"></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.row.asmblAccFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" label="关联定义">
                        <template slot-scope="rows">
                            <div class="inline-block" v-if="rows.row.assetDefId != null">已关联</div>
                            <div class="inline-block" v-else>未关联</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="price" label="含税价(元)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.price || 0.00}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="taxRate" label="税率(%)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.taxRate || 0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.ntxPrice || 0.00}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="quantity" width="80" label="下单数量"></el-table-column>
                    <el-table-column align="center" prop="unit" label="单位" width="80"></el-table-column>
                    <el-table-column align="left" prop="desc" label="说明"></el-table-column>
                </el-table>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';
    import { getMerchantBizParam } from '../asset/assetMain'
    //
    import goodsOrderApi from '../../api/goodsOrder'
    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    //
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import{ openSkuListSelectDlg } from '../goods/selectDlg'
    //
    import SwbRetailerAddrSelect from '../retailer/RetailerAddrSelect'
    Vue.regist(SwbRetailerAddrSelect);
    import SwbOrderGoodsAllocFormList from '../order/OrderGoodsAllocFormList'
    Routes.add(SwbOrderGoodsAllocFormList);
    //
    export default {
        name: 'swb-order-goods-alloc-form-detail',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '配货单详情',
        props: ['formId'],
        data: function () {
            return {
                orderGoodsAllocForm: {
                    itemList: [],
                    desireArriveDate: null
                },
                retailerCom: null,
                showAssetInfo: false,
            }
        },
        created: function () {
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = result;
            });
            //
            this.getOrderGoodsAllocFormById();
        },
        methods: {
            getOrderGoodsAllocFormById: function (formId) {
                let self = this;
                let postData = {
                    fromId: self.formId,
                };
                let loading = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFormById(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let data = result.data;
                        let orderGoodsAllocForm = data;
                        let itemList = orderGoodsAllocForm.itemList || [];
                        orderGoodsAllocForm.desireArriveDate = itemList[0].desireArriveDate;
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            item.devcName = item.title || '' + item.model || '' + item.fixedSpec || '';
                        }
                        orderGoodsAllocForm.itemList = Utils.merge([], itemList);
                        self.orderGoodsAllocForm = Utils.merge({}, orderGoodsAllocForm);
                        self.getRetailerCom(data.buyerShopId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getRetailerCom: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                }
                retailerApi.getRetailerCom(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let comId = data.id;
                        self.retailerCom = data;
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocFormDetail.vue